import { useContext, useEffect, useState } from 'react';
import LogoIcon from '../../Assets/XenieIcon.svg';
import ViewtypeButtons from './Components/ViewtypeButtons/ViewtypeButtons';
import Pagetype from './Components/Pagetype/Pagetype';
import SectiontypeButtons from './Components/SectiontypeButtons/SectiontypeButtons';
import CTAButtons from './Components/CTAButtons/CTAButtons';
import PreviewResize from './Components/PreviewResize/PreviewResize';
import UndoRedoButtons from './Components/UndoRedoButtons/UndoRedoButtons';
import { useDispatch, useSelector } from 'react-redux';
import MobileScreen from './Components/MobileScreen/MobileScreen';
import DesktopScreen from './Components/DesktopScreen/DesktopScreen';
import StoreSectionOptions from './Components/StoreSectionOptions/StoreSectionOptions';
import AboutSectionOptions from './Components/AboutSectionOptions/AboutSectionOptions';
import SingleBannerForm from './Components/SectionForms/SingleBannerForm/SingleBannerForm';
import ModalContainer from '../../Components/ModalContainer/ModalContainer';
// import { StorefrontContext } from '../../Context/StorefrontContext';
import SelectCategoryCollection from './Components/Modals/SelectCategoryCollection/SelectCategoryCollection';
import SelectCustomCollection from './Components/Modals/SelectCustomCollection/SelectCustomCollection';
import SelectCategory from './Components/Modals/SelectCategory/SelectCategory';
import SelectProduct from './Components/Modals/SelectProduct/SelectProduct';
import CarouselBannerForm from './Components/SectionForms/CarouselBannerForm/CarouselBannerForm';
import CategoryForm from './Components/SectionForms/CategoryForm/CategoryForm';
import CategoryCollectionsListForm from './Components/SectionForms/CategoryCollectionsListForm/CategoryCollectionsListForm';
import CustomCollectionsListForm from './Components/SectionForms/CustomCollectionsListForm/CustomCollectionsListForm';
import OfferDisplayForm from './Components/SectionForms/OfferDisplayForm/OfferDisplayForm';
import MediaContainer from './Components/MediaContainer/MediaContainer';
import SEOForm from './Components/SEOForm/SEOForm';
import { v4 as uuidv4 } from 'uuid';
import SelectMedia from './Components/Modals/SelectMedia/SelectMedia';
import AboutOneForm from './Components/SectionForms/AboutOneForm/AboutOneForm';
import AboutTwoForm from './Components/SectionForms/AboutTwoForm/AboutTwoForm';
import AboutThreeForm from './Components/SectionForms/AboutThreeForm/AboutThreeForm';
import FeaturesOneForm from './Components/SectionForms/FeaturesOneForm/FeaturesOneForm';
import FeaturesTwoForm from './Components/SectionForms/FeaturesTwoForm/FeaturesTwoForm';
import SingleBannerDesktopForm from './Components/SectionForms/SingleBannerDesktopForm/SingleBannerDesktopForm';
import CategoryDesktopForm from './Components/SectionForms/CategoryDesktopForm/CategoryDesktopForm';
import OfferDisplayDesktopForm from './Components/SectionForms/OfferDisplayDesktopForm/OfferDisplayDesktopForm';
import CarouselBannerDesktopForm from './Components/SectionForms/CarouselBannerDesktopForm/CarouselBannerDesktopForm';
import CategoryCollectionsListDesktopForm from './Components/SectionForms/CategoryCollectionsListDesktopForm/CategoryCollectionsListDesktopForm';
import CustomCollectionsListDesktopForm from './Components/SectionForms/CustomCollectionsListDesktopForm/CustomCollectionsListDesktopForm';
import {
    fetchMedia,
    fetchStorefront,
    fetchStorefrontAbout,
    setSelectionType,
    // setDesktopEditLinkedList,
    // setDesktopVersionList,
    // setEditLinkedList,
    setVersionList,
    updateDesktopBackgroundImage,
    updateLogoImage,
    // updateDesktopVersionIndex,
    updateVersionIndex
} from '../../Features/storefrontSlice';
import AboutOneDesktopForm from './Components/SectionForms/AboutOneDesktopForm/AboutOneDesktopForm';
import AboutTwoDesktopForm from './Components/SectionForms/AboutTwoDesktopForm/AboutTwoDesktopForm';
import AboutThreeDesktopForm from './Components/SectionForms/AboutThreeDesktopForm/AboutThreeDesktopForm';
import FeaturesOneDesktopForm from './Components/SectionForms/FeaturesOneDesktopForm/FeaturesOneDesktopForm';
import FeaturesTwoDesktopForm from './Components/SectionForms/FeaturesTwoDesktopForm/FeaturesTwoDesktopForm';
import { Link } from 'react-router-dom';
import MobilePreview from './Components/Previews/MobilePreview';
import DesktopPreview from './Components/Previews/DesktopPreview';
import { CropImageContext } from '../../Context/CropImageContext';
import CropImage from '../../Components/CropImage/CropImage';
import { getMediaUrl } from '../../lib/utils/utils';
import SwitchPageConfirmation from './Components/Modals/SwitchPageConfirmation';

function Bar() {
    return (
        <div className="w-[1px] h-9 bg-[#EAEAEA]"></div>
    )
}

function EditStore() {
    const dispatch = useDispatch();

    const {
        croppedImage,
        setCroppedImage,
        isImageCropped,
        setIsImageCropped,
        modalOpen,
        setModalOpen,
    } = useContext(CropImageContext);

    const [modalVisible, setModalVisible] = useState(false);

    const mediaSelectionType = useSelector((state) => state.storefront.mediaSelectionType);
    
    useEffect(() => {
        if(modalOpen) {
            setModalVisible(true);
        } else {
            setModalVisible(false);
        }
    }, [modalOpen]);

    const viewType = useSelector((state) => state.storefront.viewType);
    const sectionType = useSelector((state) => state.storefront.sectionType);
    const sectionFormType = useSelector((state) => state.storefront.sectionFormType);
    const pageType = useSelector((state) => state.storefront.pageType);
    const { type, open } = useSelector((state) => state.storefront.modal);
    const { storefront } = useSelector((state) => state.storefront.storefront);
    const { storefrontAbout } = useSelector((state) => state.storefront.storefrontAbout);

    const { type: previewType, open: previewOpen } = useSelector((state) => state.storefront.displayPreview);

    useEffect(() => {
        dispatch(fetchMedia());
        dispatch(fetchStorefront());
        dispatch(fetchStorefrontAbout());
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (storefront || storefront?.webStoreData?.length > 0 || storefrontAbout?.webStoreData?.length > 0) {
            let linkedList = [];
            let aboutLinkedList = [];
            let webLinkedList = [];
            let webAboutLinkedList = [];

            if(storefront?.webStoreData?.length > 0) {
                linkedList = storefront.webStoreData.map((item) => ({
                    id: uuidv4(),
                    prev: null,
                    next: null,
                    item,
                }));
                webLinkedList = storefront.webStoreData.map((item) => ({
                    id: uuidv4(),
                    prev: null,
                    next: null,
                    item,
                }));
                for(let i = 0; i < webLinkedList.length; i++) {
                    if(i < linkedList.length - 1) {
                        linkedList[i].next = linkedList[i].id;
                    }
                    if(i < webLinkedList.length - 1) {
                        webLinkedList[i].next = webLinkedList[i].id;
                    }
                }
                for(let i = 0; i < webLinkedList.length; i++) {
                    if(i > 0) {
                        linkedList[i].prev = linkedList[i - 1].next;
                    }
                    if(i > 0) {
                        webLinkedList[i].prev = webLinkedList[i - 1].next;
                    }
                }
            }

            if(storefrontAbout?.webStoreData?.length > 0) {
                aboutLinkedList = storefrontAbout.webStoreData.map((item) => ({
                    id: uuidv4(),
                    prev: null,
                    next: null,
                    item,
                }));
                webAboutLinkedList = storefrontAbout.webStoreData.map((item) => ({
                    id: uuidv4(),
                    prev: null,
                    next: null,
                    item,
                }));
                for(let i = 0; i < webAboutLinkedList.length; i++) {
                    if(i < aboutLinkedList.length - 1) {
                        aboutLinkedList[i].next = aboutLinkedList[i].id;
                    }
                    if(i < webAboutLinkedList.length - 1) {
                        webAboutLinkedList[i].next = webAboutLinkedList[i].id;
                    }
                }
                for(let i = 0; i < webAboutLinkedList.length; i++) {
                    if(i > 0) {
                        aboutLinkedList[i].prev = aboutLinkedList[i - 1].next;
                    }
                    if(i > 0) {
                        webAboutLinkedList[i].prev = webAboutLinkedList[i - 1].next;
                    }
                }
            }

            const version = {
                index: 0,
                versionData: linkedList,
                webVersionData: webLinkedList,
                backgroundImage: storefront?.BackGround || '',
                webBackgroundImage: storefront?.webBackgroundImage || '',
                logoImage: storefront?.Logo || '',
                storeAbout: aboutLinkedList,
                webStoreAbout: webAboutLinkedList,
                comment: 'Initialized',
            }
            dispatch(setVersionList(version));
            dispatch(updateVersionIndex(0));
        }
        else {
            const version = {
                index: 0,
                versionData: [],
                webVersionData: [],
                backgroundImage: storefront?.BackGround || '',
                webBackgroundImage: storefront?.webBackgroundImage || '',
                logoImage: storefront?.Logo || '',
                storeAbout: [],
                webStoreAbout: [],
                comment: 'Initialized',
            }
            dispatch(setVersionList(version));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storefront, storefrontAbout]);

    const processFile = async (file) => {
        if(file) {
            const imageUrl = await getMediaUrl(file);
            if (mediaSelectionType === 'BACKGROUND') {
                dispatch(updateDesktopBackgroundImage(imageUrl));
            }
            else if (mediaSelectionType === 'LOGO') {
                dispatch(updateLogoImage(imageUrl));
            }
        }
        else {
            return;
        }
    }

    useEffect(() => {
        if(mediaSelectionType === 'BACKGROUND' || mediaSelectionType === 'LOGO') {
            if(isImageCropped) {
                processFile(croppedImage);
                setIsImageCropped(false);
                setCroppedImage({});
                setModalOpen(false);
                dispatch(setSelectionType(null));
            }
        }
        
        // eslint-disable-next-line
    }, [isImageCropped, mediaSelectionType]);

    return (
        <>
            {
                previewOpen ? 
                <>
                    {
                        previewType === 'MOBILE' ? 
                        <MobilePreview /> : 
                        <DesktopPreview />
                    }
                </> : 
                <div className='w-screen h-screen flex'>
                    {/* Left Bar */}
                    <div className="w-[60px] border-r border-[#EAEAEA] flex flex-col">
                        <div className="px-[14px] py-3">
                            <Link to='/' className="size-8 flex items-center justify-center">
                                <img src={LogoIcon} alt="" />
                            </Link>
                        </div>

                        <SectiontypeButtons />
                    </div>

                    <div className="w-[calc(100%-60px)] flex flex-col">
                        {/* Top Bar */}
                        <div className="h-[50px] border-b border-[#EAEAEA] flex items-center justify-between select-none">
                            <Pagetype />

                            <div className="pr-4 flex items-center gap-2 h-fit">
                                <ViewtypeButtons />

                                <Bar />

                                <UndoRedoButtons />

                                <Bar />

                                <PreviewResize />

                                <Bar />

                                <CTAButtons />
                            </div>
                        </div>

                        <div className="h-[calc(100vh-50px)] w-full flex">
                            {
                                sectionType === 'SECTION' && viewType === 'DESKTOP' && 
                                (
                                    <>
                                        {pageType === 'STORE' && <StoreSectionOptions />}
                                        {pageType === 'ABOUT' && <AboutSectionOptions />}
                                    </>
                                )
                            }

                            {sectionType === 'MEDIA' && <MediaContainer />}
                            {sectionType === 'SEO' && <SEOForm />}

                            {
                                viewType === 'MOBILE' && 
                                (
                                    (sectionType === 'SECTION' || sectionType === null || sectionType === 'SEO') && 
                                    <MobileScreen />
                                )
                            }

                            {
                                viewType === 'DESKTOP' && 
                                (
                                    (sectionType === 'SECTION' || sectionType === null || sectionType === 'SEO') && 
                                    <DesktopScreen />
                                )
                            }

                            {
                                sectionType === 'SECTION' && 
                                (
                                    <>
                                        {sectionFormType === 'SINGLE_BANNER' && <SingleBannerForm />}
                                        {sectionFormType === 'SINGLE_BANNER_DESKTOP' && <SingleBannerDesktopForm />}

                                        {sectionFormType === 'CAROUSEL_BANNER' && <CarouselBannerForm />}
                                        {sectionFormType === 'CAROUSEL_BANNER_DESKTOP' && <CarouselBannerDesktopForm />}

                                        {sectionFormType === 'CATEGORY' && <CategoryForm />}
                                        {sectionFormType === 'CATEGORY_DESKTOP' && <CategoryDesktopForm />}

                                        {sectionFormType === 'CATEGORY_COLLECTION_LIST' && <CategoryCollectionsListForm />}
                                        {sectionFormType === 'CATEGORY_COLLECTION_LIST_DESKTOP' && <CategoryCollectionsListDesktopForm />}

                                        {sectionFormType === 'CUSTOM_COLLECTION_LIST' && <CustomCollectionsListForm />}
                                        {sectionFormType === 'CUSTOM_COLLECTION_LIST_DESKTOP' && <CustomCollectionsListDesktopForm />}

                                        {sectionFormType === 'OFFER_DISPLAY' && <OfferDisplayForm />}
                                        {sectionFormType === 'OFFER_DISPLAY_DESKTOP' && <OfferDisplayDesktopForm />}

                                        {sectionFormType === 'ABOUT_ONE' && <AboutOneForm />}
                                        {sectionFormType === 'ABOUT_ONE_DESKTOP' && <AboutOneDesktopForm />}

                                        {sectionFormType === 'ABOUT_TWO' && <AboutTwoForm />}
                                        {sectionFormType === 'ABOUT_TWO_DESKTOP' && <AboutTwoDesktopForm />}

                                        {sectionFormType === 'ABOUT_THREE' && <AboutThreeForm />}
                                        {sectionFormType === 'ABOUT_THREE_DESKTOP' && <AboutThreeDesktopForm />}

                                        {sectionFormType === 'FEATURES_ONE' && <FeaturesOneForm />}
                                        {sectionFormType === 'FEATURES_ONE_DESKTOP' && <FeaturesOneDesktopForm />}

                                        {sectionFormType === 'FEATURES_TWO' && <FeaturesTwoForm />}
                                        {sectionFormType === 'FEATURES_TWO_DESKTOP' && <FeaturesTwoDesktopForm />}
                                    </>
                                )
                            }
                        </div>
                    </div>

                    {
                        open && 
                        <ModalContainer>
                            {type === 'select-category-collection' && <SelectCategoryCollection />}

                            {type === 'select-custom-collection' && <SelectCustomCollection />}

                            {type === 'select-category' && <SelectCategory />}

                            {type === 'select-product' && <SelectProduct />}

                            {type === 'media-files' && <SelectMedia />}

                            {type === 'confirm-switch-page' && <SwitchPageConfirmation />}
                        </ModalContainer>
                    }

                    {
                        modalOpen && 
                        <div className={`${modalVisible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 w-full h-full top-0 left-0 flex justify-center items-center`}>
                            <CropImage />
                        </div>
                    }
                </div>
            }
        </>
    );
}

export default EditStore;